import { FETCH_INVOICES } from '../actionTypes';
import { hideLoader, showLoader } from "./loader"
import axios from 'axios';

const SERVICE = 'invoices';

export const createStatement = () => (dispatch) => {
  return new Promise((response, reject) => {
  })
}

export const fetchList = (userId) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  dispatch(showLoader());
  return new Promise((respond,rej) => {
    axios.get(SERVICE).then((res) => {
      dispatch(hideLoader());
      dispatch({
        type: FETCH_INVOICES,
        payload: res.data
      });
      respond(res.data);
    });
  });
}

export const fetchInfo = (statementId) => (dispatch) => {
  return new Promise((respond,rej) => {
  });
}



// WEBPACK FOOTER //
// ./src/store/actions/invoices.js